/**********************************
 * Types Action Authentication
 **/
export const SIGNUP_SUCCESS: string = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL: string = "SIGNUP_FAIL";

export const ACCOUNT_ACTIVATION_SUCCESS: string = "ACCOUNT_ACTIVATION_SUCCESS";
export const ACCOUNT_ACTIVATION_FAIL: string = "ACCOUNT_ACTIVATION_FAIL";

export const LOGIN_SUCCESS: string = "LOGIN_SUCCESS";
export const LOGIN_FAIL: string = "LOGIN_FAIL";

export const VERIFY_TOKEN_SUCCESS: string = "VERIFY_TOKEN_SUCCESS";
export const VERIFY_TOKEN_FAIL: string = "VERIFY_TOKEN_FAIL";

export const REFRESH_TOKEN_SUCCESS: string = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAIL: string = "REFRESH_TOKEN_FAIL";

export const AUTHENTICATED_SUCCESS: string = "AUTHENTICATED_SUCCESS";
export const AUTHENTICATED_FAIL: string = "AUTHENTICATED_FAIL";

export const REQUEST_RESET_PASSWORD_SUCCESS: string = "REQUEST_RESET_PASSWORD_SUCCESS";
export const REQUEST_RESET_PASSWORD_FAIL: string = "REQUEST_RESET_PASSWORD_FAIL";

export const RESET_PASSWORD_SUCCESS: string = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL: string = "RESET_PASSWORD_FAIL";

export const LOGOUT: string = "LOGOUT";



/**********************************
 * Types Action User
 **/
export const GET_CURRENT_USER_LOADED_SUCCESS: string = "GET_CURRENT_USER_LOADED_SUCCESS";
export const GET_CURRENT_USER_LOADED_FAIL: string = "GET_CURRENT_USER_LOADED_FAIL";

export const UPDATE_PROFILE_CURRENT_USER_LOADED_SUCCESS: string = "UPDATE_PROFILE_CURRENT_USER_LOADED_SUCCESS";
export const UPDATE_PROFILE_CURRENT_USER_LOADED_FAIL: string = "UPDATE_PROFILE_CURRENT_USER_LOADED_FAIL";

export const GET_ALL_USERS_LOADED_SUCCESS: string = "GET_ALL_USERS_LOADED_SUCCESS";
export const GET_ALL_USERS_LOADED_FAIL: string = "GET_ALL_USERS_LOADED_FAIL";



/**********************************
 * Types Action Post and LikePost
 **/
export const GET_ALL_POST_SUCCESS: string = "GET_ALL_POST_SUCCESS";
export const GET_ALL_POST_FAIL: string = "GET_ALL_POST_FAIL";

export const GET_ONE_POST_SUCCESS: string = "GET_ONE_POST_SUCCESS";
export const GET_ONE_POST_FAIL: string = "GET_ONE_POST_FAIL";

export const ADD_NEW_POST_SUCCESS: string = "ADD_NEW_POST_SUCCESS";
export const ADD_NEW_POST_FAIL: string = "ADD_NEW_POST_FAIL";

export const UPDATE_POST_SUCCESS: string = "UPDATE_POST_SUCCESS";
export const UPDATE_POST_FAIL: string = "UPDATE_POST_FAIL";

export const DELETE_POST_SUCCESS: string = "DELETE_POST_SUCCESS";
export const DELETE_POST_FAIL: string = "DELETE_POST_FAIL";

export const LIKE_OR_UNLIKE_POST_SUCCESS: string = "LIKE_OR_UNLIKE_POST_SUCCESS";
export const LIKE_OR_UNLIKE_POST_FAIL: string = "LIKE_OR_UNLIKE_POST_FAIL";

export const GET_LIKE_OR_UNLIKE_POST_SUCCESS: string = "GET_LIKE_OR_UNLIKE_POST_SUCCESS";
export const GET_LIKE_OR_UNLIKE_POST_FAIL: string = "GET_LIKE_OR_UNLIKE_POST_FAIL";

export const UPDATE_LIKE_OR_UNLIKE_POST_SUCCESS: string = "UPDATE_LIKE_OR_UNLIKE_POST_SUCCESS";
export const UPDATE_LIKE_OR_UNLIKE_POST_FAIL: string = "UPDATE_LIKE_OR_UNLIKE_POST_FAIL";

export const GET_LIST_POSTS_LIKES_SUCCESS: string = "GET_LIST_POSTS_LIKES_SUCCESS";
export const GET_LIST_POSTS_LIKES_FAIL: string = "GET_LIST_POSTS_LIKES_FAIL";



/**********************************
 * Types Comment and LikeComment
 **/
export const GET_ALL_COMMENT_SUCCESS: string = "GET_ALL_COMMENT_SUCCESS";
export const GET_ALL_COMMENT_FAIL: string = "GET_ALL_COMMENT_FAIL";

export const GET_ONE_COMMENT_SUCCESS: string = "GET_ONE_COMMENT_SUCCESS";
export const GET_ONE_COMMENT_FAIL: string = "GET_ONE_COMMENT_FAIL";

export const ADD_NEW_COMMENT_SUCCESS: string = "ADD_NEW_COMMENT_SUCCESS";
export const ADD_NEW_COMMENT_FAIL: string = "ADD_NEW_COMMENT_FAIL";

export const UPDATE_COMMENT_SUCCESS: string = "UPDATE_COMMENT_SUCCESS";
export const UPDATE_COMMENT_FAIL: string = "UPDATE_COMMENT_FAIL";

export const DELETE_COMMENT_SUCCESS: string = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAIL: string = "DELETE_COMMENT_FAIL";

export const LIKE_OR_UNLIKE_COMMENT_SUCCESS: string = "LIKE_OR_UNLIKE_COMMENT_SUCCESS";
export const LIKE_OR_UNLIKE_COMMENT_FAIL: string = "LIKE_OR_UNLIKE_COMMENT_FAIL";



/**********************************
 * Types Following and Followers
 **/
export const GET_ALL_FOLLOWING_SUCCESS: string = "GET_ALL_FOLLOWING_SUCCESS";
export const GET_ALL_FOLLOWING_FAIL: string = "GET_ALL_FOLLOWING_FAIL";

export const ADD_FOLLOWING_SUCCESS: string = "ADD_FOLLOWING_SUCCESS";
export const ADD_FOLLOWING_FAIL: string = "ADD_FOLLOWING_FAIL";

export const GET_ALL_FOLLOWERS_SUCCESS: string = "GET_ALL_FOLLOWERS_SUCCESS";
export const GET_ALL_FOLLOWERS_FAIL: string = "GET_ALL_FOLLOWERS_FAIL";

export const GET_PEOPLE_CONNECT_SUCCESS: string = "GET_PEOPLE_CONNECT_SUCCESS";
export const GET_PEOPLE_CONNECT_FAIL: string = "GET_PEOPLE_CONNECT_FAIL";



/**********************************
 * Types Notification
 **/
export const GET_NOTIFICATION_SUCCESS: string = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAIL: string = "GET_NOTIFICATION_FAIL";

export const READ_NOTIFICATION_SUCCESS: string = "READ_NOTIFICATION_SUCCESS";
export const READ_NOTIFICATION_FAIL: string = "READ_NOTIFICATION_FAIL";



/**********************************
 * Types Notification Messsges
 **/
export const GET_MESSAGES_SUCCESS: string = "GET_MESSAGES_SUCCESS";
export const GET_MESSAGES_FAIL: string = "GET_MESSAGES_FAIL";

export const PREVIEW_NOTIFICATION_MESSAGES_SUCCESS: string = "PREVIEW_NOTIFICATION_MESSAGES_SUCCESS";
export const PREVIEW_NOTIFICATION_MESSAGES_FAIL: string = "PREVIEW_NOTIFICATION_MESSAGES_FAIL";



/**********************************
 * Types Bookmark
 **/
export const ADD_BOOKMARK_SUCCESS: string = "ADD_BOOKMARK_SUCCESS";
export const ADD_BOOKMARK_FAIL: string = "ADD_BOOKMARK_FAIL";

export const GET_BOOKMARKS_SUCCESS: string = "GET_BOOKMARKS_SUCCESS";
export const GET_BOOKMARKS_FAIL: string = "GET_BOOKMARKS_FAIL";



/**********************************
 * Types Message
 **/
export const GET_MESSAGE_SUCCESS: string = "GET_MESSAGE_SUCCESS";
export const GET_MESSAGE_FAIL: string = "GET_MESSAGE_FAIL";